<template>
  <ion-page>
    <ion-content class="white">
      <CodeVerifyComponent @formSubmitVerify="submitVerify" :is-change-email-page="true" />
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonContent, alertController,
} from "@ionic/vue";
import request from '../../../utils/Request';
import CodeVerifyComponent from "../../../components/CodeVerify.vue";
import StorageService from '../../../utils/StorageService'
import type { User } from '@/models/storage'
import {goBackToMembershipCard} from "@/helpers/platform";

async function submitVerify(form: any) {
  const data = {
    is_change_email: true,
    email: form.email,
    code: form.code,
    device_uuid: await StorageService.get('deviceUuid'),
  }

  try {
    const res = await request.post<{ access_token: string, user: any }>('/mypage/verify-otp-code-change-email', data);
    if (!res.status) {
      return
    }
    // ローカルストレージの値更新
    const user: User = {
      id: res.data.user.id,
      is_registered: res.data.user.is_registered,
      is_updated_profile: res.data.user.is_updated_profile,
    }
    await StorageService.set('user', user)
    const alert = await alertController.create({
      header: 'メールアドレスを変更しました。',
      buttons: [ {
        text: '閉じる',
        handler: () => {
          goBackToMembershipCard();
        }
      }],
    })

    await alert.present()
  } catch(err: any) {
    if (err.response?.status == 422) {
      form.formVerifyCode.setErrors(err.response.data.errors);
    }
  }
}
</script>

<style scoped></style>
